import gql from "graphql-tag";

export const EDIT_THERAPIST_INFORMATION = gql`
  mutation EditTherapistInformationByUuid(
    $therapistUuid: ID!
    $attribute: String!
    $value: String!
  ) {
    editTherapistInformationByUuid(
      therapistUuid: $therapistUuid
      attribute: $attribute
      value: $value
    ) {
      therapist {
        id
        timeZone
      }
      returnMessage {
        status
        message
      }
    }
  }
`;
